import { generateMedia } from 'styled-media-query'

export const defaultMedias = {
  small: '32.5rem',
  medium: '48rem',
  large: '62rem',
  xLarge: '75rem',
  xxLarge: '90rem',
}
export default generateMedia(defaultMedias)
